import { SlidersHorizontal } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useVideoFeedFilter } from '@/hooks/useVideoFeedFilter';

/**
 * Filter toggles for video listings: reported videos, YouTube-link videos,
 * and videos without a determinable duration. Reported videos are hidden by
 * default. Preferences persist across sessions.
 */
export function FeedFilterDropdown() {
  const { filter, updateFilter } = useVideoFeedFilter();

  const activeCount =
    (filter.showReported ? 1 : 0) +
    (!filter.showYouTube ? 1 : 0) +
    (!filter.showUnknownDuration ? 1 : 0) +
    (!filter.showNoteVideos ? 1 : 0);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-1.5">
          <SlidersHorizontal className="h-4 w-4" />
          Filters
          {activeCount > 0 && (
            <span className="ml-1 rounded-full bg-primary px-1.5 text-[10px] font-bold text-primary-foreground">
              {activeCount}
            </span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-72">
        <DropdownMenuLabel>Video filters</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuCheckboxItem
          checked={filter.showReported}
          onCheckedChange={(checked) => updateFilter({ showReported: checked === true })}
          className="py-2"
        >
          <div className="flex flex-col gap-0.5">
            <span>Show reported videos</span>
            <span className="text-xs text-muted-foreground font-normal">
              Videos with kind 1984 reports are hidden by default
            </span>
          </div>
        </DropdownMenuCheckboxItem>
        <DropdownMenuCheckboxItem
          checked={filter.showYouTube}
          onCheckedChange={(checked) => updateFilter({ showYouTube: checked === true })}
          className="py-2"
        >
          <div className="flex flex-col gap-0.5">
            <span>Show YouTube-link videos</span>
            <span className="text-xs text-muted-foreground font-normal">
              Videos that link to YouTube instead of media files
            </span>
          </div>
        </DropdownMenuCheckboxItem>
        <DropdownMenuCheckboxItem
          checked={filter.showUnknownDuration}
          onCheckedChange={(checked) => updateFilter({ showUnknownDuration: checked === true })}
          className="py-2"
        >
          <div className="flex flex-col gap-0.5">
            <span>Show videos of unknown length</span>
            <span className="text-xs text-muted-foreground font-normal">
              Videos whose duration can't be determined
            </span>
          </div>
        </DropdownMenuCheckboxItem>
        <DropdownMenuCheckboxItem
          checked={filter.showNoteVideos}
          onCheckedChange={(checked) => updateFilter({ showNoteVideos: checked === true })}
          className="py-2"
        >
          <div className="flex flex-col gap-0.5">
            <span>Show videos from notes</span>
            <span className="text-xs text-muted-foreground font-normal">
              Kind 1 notes linking video files (the "Notes" tab)
            </span>
          </div>
        </DropdownMenuCheckboxItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
